export var getMandantMenuItems = function (navigate) {
    return [
        {
            label: "Dashboard",
            icon: "pi pi-home",
            command: function () { return navigate("/client/dashboard"); },
        }
    ];
};
